var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlowbiteProfileCardOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 18.7498H37.5M31.25 24.9998H37.5M31.25 31.2498H37.5M25 33.3332C24.375 32.0832 22.9167 31.2498 21.6667 31.2498H15.8333C14.375 31.2498 13.125 32.0832 12.5 33.3332M8.33333 10.4165H41.6667C42.9167 10.4165 43.75 11.2498 43.75 12.4998V37.4998C43.75 38.7498 42.9167 39.5832 41.6667 39.5832H8.33333C7.7808 39.5832 7.25089 39.3637 6.86019 38.973C6.46949 38.5823 6.25 38.0524 6.25 37.4998V12.4998C6.25 11.2498 7.08333 10.4165 8.33333 10.4165ZM22.9167 20.8332C22.9167 21.9382 22.4777 22.998 21.6963 23.7794C20.9149 24.5608 19.8551 24.9998 18.75 24.9998C17.6449 24.9998 16.5851 24.5608 15.8037 23.7794C15.0223 22.998 14.5833 21.9382 14.5833 20.8332C14.5833 19.7281 15.0223 18.6683 15.8037 17.8869C16.5851 17.1055 17.6449 16.6665 18.75 16.6665C19.8551 16.6665 20.9149 17.1055 21.6963 17.8869C22.4777 18.6683 22.9167 19.7281 22.9167 20.8332Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowbiteProfileCardOutline);
export default __webpack_public_path__ + "static/media/flowbite_profile-card-outline.14649664c8404561acaf7e06c2be92b7.svg";
export { ForwardRef as ReactComponent };